import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserShield, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { deleteRoleAsync, deleteRoleStaff } from "src/redux/actions/manageUserActions";
import { AppDispatch } from "src/redux/store"; // Adjust import based on your store setup
import { Role } from "src/interfaces/ManageUsersAndRole.interface";
import useAppToast from "src/hooks/useAppToast";
import { useAppSelector } from "src/redux/storeHooks";

interface DeleteRoleModalProps {
  show: boolean;
  handleClose: () => void;
  role: Role | null; // More specific typing
  fetchData: ()=> void;
}

const DeleteRoleModal: React.FC<DeleteRoleModalProps> = ({ show, handleClose, role, fetchData }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData);
  const isSuperAdmin = fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.account_type === "ADMIN_STAFF";
  const [loading, setLoading] = useState(false);
  const { successToast, errorToast } = useAppToast();
  const handleConfirm = async () => {
    if (!role?.id) return;
    setLoading(true);
    const actionApi = isSuperAdmin ? deleteRoleAsync : deleteRoleStaff;
    await dispatch(actionApi({ id: role.id }))
    .then((response)=>{
        if(response.payload.status_code == 200){
            successToast(response.payload.massage)
          }
          if(response?.payload?.data?.status_code === 400) {
            errorToast(response?.payload?.data?.massage);
          }
          fetchData();
          handleClose();
      })
      .catch((error)=>{
        errorToast('Failed to add role.');
      })
      .finally(()=> setLoading(false))
    };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header className="bg-danger text-white border-0">
        <Modal.Title className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faUserShield} />
          Delete Role
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="text-warning mb-3"
          size="2x"
        />
        <p className="fs-5 mb-2">
          Are you sure you want to delete the role <strong>{role?.name}</strong>?
        </p>
        <p className="text-muted">
          This will permanently remove the role and its associated permissions.
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Deleting...
            </>
          ) : (
            "Yes, Delete Role"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRoleModal;
